import React from "react";
import Channel from "./ChannelMapper/Channel";

export default function Channels({ hotelId }) {
  return <Channel hotelId={hotelId} />;
}
